module.exports = __webpack_public_path__ + "static/img/equip2.867dfef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coreValues/equip2.png
// module id = 0+83
// module chunks = 2